import { render, staticRenderFns } from "./InviteCustomer.vue?vue&type=template&id=952521fe&"
import script from "./InviteCustomer.vue?vue&type=script&lang=js&"
export * from "./InviteCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports